var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBottom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 1,
  y: 1,
  fill: "#5C5F62",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.695 14.614h10.92a.693.693 0 1 1 0 1.386H4.696a.693.693 0 0 1 0-1.386",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.5 10.172V3.366a.75.75 0 0 1 1.5 0v6.805h2.25l-3 2.993-3-2.992z"
})));
export default SvgBottom;